<div class="d-flex justify-content-center p-5 mt-5">
  <i class="fa-solid fa-gear fa-spin fa-spin-reverse fa-2xl loading-gear"></i>
  <i class="fa-solid fa-gear fa-spin fa-2xl loading-gear loading-gear-mid"></i>
  <i class="fa-solid fa-gear fa-spin fa-spin-reverse fa-2xl loading-gear"></i>
</div>
